module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1087.d3dc5be6.png";